(function () {
  'use strict';
  var experiment = window.zcCartExperiment;
  if (!experiment) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function publish(name, payload) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('zaltify:' + name, Object.assign({
        experiment: experiment.name, group: experiment.group
      }, payload || {}));
    }
  }
  function init() {
    var sessionKey = 'zc_cart_ab_session_v1';
    try {
      if (sessionStorage.getItem(sessionKey) !== experiment.group) {
        sessionStorage.setItem(sessionKey, experiment.group);
        publish('cart_ab_session', {path:location.pathname});
      }
    } catch (e) { publish('cart_ab_session', {path:location.pathname}); }
    if (typeof window.clarity === 'function') window.clarity('set','zaltify_cart_ab',experiment.group);
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      var exposed=false;
      function check() {
        var dialog=drawer.querySelector('.cart-drawer__dialog');
        if (!exposed && dialog && dialog.hasAttribute('open')) {
          exposed=true;
          publish('cart_ab_drawer_open', {path:location.pathname});
        }
      }
      check();
      new MutationObserver(check).observe(drawer,{subtree:true,attributes:true,attributeFilter:['open']});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('click',async function(event) {
    var button = event.target.closest && event.target.closest('[data-zc-upsell-add]');
    if (!button || experiment.group !== 'treatment' || button.disabled) return;
    event.preventDefault();
    var original = button.textContent;
    var variant = parseInt(button.dataset.variantId,10);
    if (!variant) return;
    button.disabled=true;
    button.textContent='…';
    var card=button.closest('.zc-cart-upsell');
    var badge=card?.querySelector('[data-zc-upsell-free-shipping]');
    var unlockedShipping=Boolean(badge && !badge.hidden);
    var status=card?.querySelector('.zc-cart-upsell__status');
    try {
      var sections=Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function(node){return node.dataset.sectionId;}).filter(Boolean)));
      var response=await fetch(root+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:variant,quantity:1,properties:{_zaltify_cart_upsell:'cart_cro_v1',_zaltify_free_shipping_upsell:unlockedShipping?'yes':'no'}}],sections:sections.join(','),sections_url:location.pathname})
      });
      var data=await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || 'Could not add product');
      publish('cart_ab_upsell_added',{variant_id:variant,free_shipping_unlock:unlockedShipping});
      // Offer at most one successful upsell per cart (normal product additions don't count).
      experiment.upsellAccepted = true;
      document.documentElement.setAttribute('data-zc-upsell-accepted','true');
      document.dispatchEvent(new CustomEvent('zaltify:cart-upsell-accepted', { detail:{ variantId:variant }}));
      if(data.sections) {
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{
          resource:data,sourceId:'zaltify-cart-upsell',
          data:{source:'zaltify-cart-upsell',sections:data.sections,itemCount:data.item_count}
        }}));
      } else {location.reload();}
    } catch(err) {
      button.disabled=false;
      button.textContent=original;
      if(status) status.textContent=err.message || 'Please try again';
    }
  });
})();